import { TLD } from '@packages/common';

const USER_ROUTE = '/user';
const NEWSLETTER_ROUTE = '/newsletter';

export async function updateNewsletterPreference(
  url: string,
  info: { newsletterPermission: boolean; tld: TLD },
): Promise<{ success: boolean }> {
  return fetch(`${url}${USER_ROUTE}`, {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(info),
  })
    .then((res) => res.json())
    .catch((err) => console.log(err));
}

export function enrollForNewsletter(
  url: string,
  info: { email: string; tld: TLD; tag?: string },
): Promise<{ error_key?: string; email_sha256: string }> {
  return new Promise((resolve, reject) => {
    fetch(`${url}${NEWSLETTER_ROUTE}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(info),
    }).then(async (res) => {
      const response = await res.json();

      if (res.status == 200 || res.status == 201) {
        resolve(response);
      } else {
        reject(response);
      }
    });
  });
}
